export default __webpack_public_path__ + "static/media/A Token of Friendship.9d22169a.png";